module.exports = __webpack_public_path__ + "assets/img/back-2.83324b45.png";